var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"tit-block"},[_c('img',{staticClass:"logo",attrs:{"src":require("./assets/logo1.png"),"alt":""}}),_vm._v("\n    圣湘生物 （688289）— 生命科技人人可及\n    "),(_vm.$route.name!== 'register')?_c('div',{staticClass:"login-out",on:{"click":_vm.loginOut}},[_vm._v("退出")]):_vm._e()]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63706afe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 